import { List } from '@ksyos/design-system';
import { getSelectedLanguage } from '../../../../../translate';

export function PatientQuestionnaireExtraDetails() {
    const {
        osasPermission: { patientQuestionnaireExtraDetails_1, patientQuestionnaireExtraDetails_2 },
    } = getSelectedLanguage();

    return (
        <List
            size="small"
            styleType="bullet"
            sx={{ marginLeft: 6 }}
        >
            <List.Item>{patientQuestionnaireExtraDetails_1}</List.Item>
            <List.Item>{patientQuestionnaireExtraDetails_2}</List.Item>
        </List>
    );
}
